module.exports = __webpack_public_path__ + "img/26m.b2fc03e7.png";